// src/components/Layout.jsx
import React from "react";
import TopBar from "./TopBar/TopBar";
import Navbar from "./Navbar/index.js";

export default function Layout({ children }) {
  return (
    <>
      <TopBar message="هزینۀ ارسال سفارش‌های بالای یک میلیون تومان، به تمامی نقاط ایران، رایگان است." />
      <Navbar />
      <main style={{ marginTop: "0px" }}>{children}</main> {/* adjust margin for TopBar height */}
    </>
  );
}
